import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './Details'
import ServiceOrderLoader from './_load/ServiceOrderLoader'

const EditServiceOrdersUserModal = props => {
  return (
    <ControlledModal width="38rem" {...props}>
      <ServiceOrderLoader>
        <Details />
      </ServiceOrderLoader>
    </ControlledModal>
  )
}

export default EditServiceOrdersUserModal
